import { HStack, Progress, Text, VStack } from '@chakra-ui/react'
import { AlertTriangle } from 'lucide-react'

interface UsageGaugeProps {
  label: string
  current: number
  limit: number // -1 = illimité
  unit?: string
}

export function UsageGauge({ label, current, limit, unit = '' }: UsageGaugeProps) {
  const isUnlimited = limit === -1
  const percentage = isUnlimited ? 0 : Math.round((current / limit) * 100)
  const isNearLimit = percentage >= 80
  const isAtLimit = percentage >= 100

  const getColor = () => {
    if (isUnlimited) return 'blue'
    if (isAtLimit) return 'red'
    if (isNearLimit) return 'orange'
    return 'green'
  }

  return (
    <VStack align="stretch" gap={2}>
      <HStack justify="space-between">
        <Text fontWeight="medium" fontSize="sm">
          {label}
        </Text>
        <HStack gap={2}>
          {isNearLimit && !isUnlimited && <AlertTriangle size={16} color="#f97316" />}
          <Text fontSize="sm" fontWeight="semibold" color={`${getColor()}.600`}>
            {current} / {isUnlimited ? '∞' : `${limit}${unit ? ` ${unit}` : ''}`}
          </Text>
        </HStack>
      </HStack>

      {!isUnlimited && (
        <Progress.Root value={Math.min(percentage, 100)} colorPalette={getColor()} size="sm">
          <Progress.Track borderRadius="full">
            <Progress.Range />
          </Progress.Track>
        </Progress.Root>
      )}

      {isUnlimited && (
        <Text fontSize="xs" color="gray.500">
          Utilisation illimitée
        </Text>
      )}
    </VStack>
  )
}
